import React from 'react'
import {Link, useNavigate, useSearchParams} from "react-router-dom";
import Sidebar from "../../../../../components/Sidebar";
import PageHeader from "../../../../../components/PageHeader";
import {toast} from "react-toastify";
import moment from "moment";
import DatePicker, {registerLocale} from "react-datepicker";
import {getSchoolYear} from "../../../../../utils/authority";
import GradeManager from "../../../../../components/Grade";
import ClassRoomController from "../../../../../services/data-declaration/class-room-controller";
import AddressManager from "../../../../../components/Address";
import StudentController from "../../../../../services/system/student/student-controller";
import vi from "date-fns/locale/vi";
registerLocale("vi", vi);
function withRouter(Component) {
    return (props) => <Component {...props} navigate={useNavigate()} params={useSearchParams()} />;
}
class EditMenuManagement extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            "autoGenCode": true,
            "bietBoi": true,
            "birthday": null,
            "birthdayFather": null,
            "birthdayGiamHo": null,
            "birthdayMother": null,
            "cheDoChinhSach": "CHE_DO_CHINH_SACH_1",
            "cheDoHoTro": "CHE_DO_HO_TRO_1",
            "choO": "TRONG_TRUONG",
            "code": "",
            "currentClassRoomId": 0,
            "dangDay": null,
            "dangVien": true,
            "dienHocSinh": "DIEN_HOC_SINH_1",
            "districtCode": "",
            "doanDay": null,
            "doanVien": true,
            "doiDay": null,
            "doiTuongUuTien": "UU_TIEN_1",
            "doiVien": true,
            "email": "",
            "ethnic": "KINH",
            "fatherDanToc": true,
            "fullName": "",
            "fullNameFather": "",
            "fullNameGiamHo": "",
            "fullNameMother": "",
            "gender": "MALE",
            "grade": "GRADE_1",
            "heHocNN": "TIENG_ANH",
            "hinhThuc": "TRUNG_TUYEN",
            "identify": "",
            "ishocTruongTrinhGDBo": true,
            "iskhuyetTat": true,
            "jobFather": "",
            "jobGiamHo": "",
            "jobMother": "",
            "khuyetTat": "KHUYET_TAT_1",
            "mailFather": "",
            "mailGiamHo": "",
            "mailMother": "",
            "motherDanToc": true,
            "nhomMau": "NHOM_MAU_1",
            "noiSinh": "",
            "phone": "",
            "phoneFather": "",
            "phoneGiamHo": "",
            "phoneHome": "",
            "phoneMother": "",
            "pointDegree": "TRUNG_BINH",
            "provinceCode": "",
            "queQuan": "",
            "religion": "NO",
            "schoolDay":null,
            "sodangbo": "",
            "state": "NGHI_HOC",
            "taiDinhCu": true,
            "tamTru": "",
            "tengoiEthnnic": "",
            "thanhPhanParent": "THANH_PHAN_PARENT_1",
            "thuongTru": "",
            "wardCode": "",
            "address": "",
            yearId: parseInt(getSchoolYear()),
            "zone": "",

            listClassRoom: [],
        };
    }

    componentWillMount() {
        const [searchparams] = this.props.params;
        let studentId = searchparams.get("id");
        this.getListClassRoom()
        this.getDetailStudent(studentId)
    }
    getDetailStudent = (studentId) => {
        StudentController.detail(studentId, res => {
            let data = res.data
            console.log(data)
            if (res.success){
                this.setState({
                    "id": data.id,
                    "gradeId": data.grade,
                    "bietBoi": data.bietBoi,
                    "birthday": data.birthday,
                    "birthdayFather": data.birthdayFather,
                    "birthdayGiamHo": data.birthdayGiamHo,
                    "birthdayMother": data.birthdayMother,
                    "cheDoChinhSach": data.cheDoChinhSach,
                    "cheDoHoTro":  data.cheDoHoTro,
                    "choO": data.choO,
                    "code": data.code,
                    "currentClassRoomId": data.currentClassRoomRes?.id,
                    "dangDay": data.dangDay,
                    "dangVien":  data.dangVien,
                    "dienHocSinh": data.dienHocSinh,
                    "districtId": data.districtRes?.code,
                    "doanDay": data.doanDay,
                    "doanVien": data.doanVien,
                    "doiDay": data.doiDay,
                    "doiTuongUuTien": data.doiTuongUuTien,
                    "doiVien": data.doiVien,
                    "email": data.email,
                    "ethnic": data.ethnic,
                    "fatherDanToc":  data.fatherDanToc,
                    "fullName": data.fullName,
                    "fullNameFather":  data.fullNameFather,
                    "fullNameGiamHo":  data.fullNameGiamHo,
                    "fullNameMother":  data.fullNameMother,
                    "gender":  data.gender,
                    "grade":  data.grade,
                    "heHocNN":  data.heHocNN,
                    "hinhThuc":  data.hinhThuc,
                    "identify":  data.identify,
                    "ishocTruongTrinhGDBo":  data.ishocTruongTrinhGDBo,
                    "iskhuyetTat":  data.iskhuyetTat,
                    "jobFather":  data.jobFather,
                    "jobGiamHo":  data.jobGiamHo,
                    "jobMother":  data.jobMother,
                    "khuyetTat": data.khuyetTat,
                    "mailFather": data.mailFather,
                    "mailGiamHo": data.mailGiamHo,
                    "mailMother": data.mailMother,
                    "motherDanToc": data.motherDanToc,
                    "nhomMau": data.nhomMau,
                    "noiSinh": data.noiSinh,
                    "phone":  data.noiSinh,
                    "phoneFather":  data.phoneFather,
                    "phoneGiamHo":  data.phoneGiamHo,
                    "phoneHome":  data.phoneHome,
                    "phoneMother":  data.phoneMother,
                    "pointDegree":  data.pointDegree,
                    "provinceId":  data.provinceRes?.code,
                    "queQuan":  data.queQuan,
                    "religion":  data.religion,
                    "schoolDay": data.schoolDay,
                    "sodangbo": data.sodangbo,
                    "state": data.state,
                    "taiDinhCu": data.taiDinhCu,
                    "tamTru": data.tamTru,
                    "address": data.tamTru,
                    "tengoiEthnnic": data.tengoiEthnnic,
                    "thanhPhanParent": data.thanhPhanParent,
                    "thuongTru": data.thuongTru,
                    "wardId": data.wardRes?.code,
                })
            } else {
                toast.error("Đã xảy ra lỗi! " + res.message)
            }

        })
    };
    getListClassRoom = () => {
        let payload = {
            yearId: parseInt(getSchoolYear()),
            pageNumber: this.state.pageNumber,
            pageSize: this.state.pageSize,
            "sort": "created_at desc"
        };
        ClassRoomController.list(payload, res => {
            this.setState({
                showLoading: false,
                listClassRoom: res.data.content,
                totalItem: res.data.totalElements,
                totalPage: Math.round(res.data.totalElements / this.state.pageSize)
            });
        })
    };
    renderClassRoom = () => {
        return this.state.listClassRoom.map((item, index) => <option
            value={item.id}>{item.name}</option>)
    };
    onEdit = () => {
        let {fullName} = this.state;
        if (fullName == "" || fullName.length < 5){
            toast.error("Tên học sinh phải lớn hơn 6 ký tự");
        }else if(this.state.gradeId == ""){
            toast.error("Vui lòng chọn khối học");
        }else if(this.state.address == "" || this.state.wardId == undefined || this.state.provinceId==undefined || this.state.districtId == undefined){
            toast.error("Vui lòng nhập địa chỉ học sinh");
        }else if (!(this.state.fullNameFather !== "" && this.state.birthdayFather !== "" && this.state.jobFather !== ""  && this.state.phoneFather !== ""  && this.state.mailFather !== "") &&
            !(this.state.fullNameMother !== "" && this.state.birthdayMother !== "" && this.state.jobMother !== ""  && this.state.phoneMother !== ""  && this.state.mailMother !== "") &&
            !(this.state.fullNameGiamHo !== "" && this.state.birthdayGiamHo !== "" && this.state.jobGiamHo !== ""  && this.state.phoneGiamHo !== ""  && this.state.mailGiamHo !== "")
        ) {
            toast.error("Vui lòng nhập đủ thông tin của ít nhất 1 người(Bố hoặc mẹ hoặc người giám hộ");
        }else {
            let payload = {
                "id": this.state.id,
                "autoGenCode": this.state.autoGenCode,
                "bietBoi": this.state.bietBoi,
                "birthday": this.state.birthday,
                "birthdayFather": this.state.birthdayFather,
                "birthdayGiamHo": this.state.birthdayGiamHo,
                "birthdayMother": this.state.birthdayMother,
                "cheDoChinhSach": this.state.cheDoChinhSach,
                "cheDoHoTro": this.state.cheDoHoTro,
                "choO": this.state.choO,
                "code": this.state.code,
                "currentClassRoomId": this.state.currentClassRoomId,
                "dangDay": this.state.dangDay,
                "dangVien":  this.state.dangVien,
                "dienHocSinh": this.state.dienHocSinh,
                "districtCode": this.state.districtId,
                "doanDay": this.state.doanDay,
                "doanVien": this.state.doanVien,
                "doiDay": this.state.doiDay,
                "doiTuongUuTien": this.state.doiTuongUuTien,
                "doiVien": this.state.doiVien,
                "email": this.state.email,
                "ethnic": this.state.ethnic,
                "fatherDanToc":  this.state.fatherDanToc,
                "fullName": this.state.fullName,
                "fullNameFather":this.state.fullNameFather,
                "fullNameGiamHo": this.state.fullNameGiamHo,
                "fullNameMother": this.state.fullNameMother,
                "gender": this.state.gender,
                "grade": this.state.grade,
                "heHocNN": this.state.heHocNN,
                "hinhThuc": this.state.hinhThuc,
                "identify": this.state.identify,
                "ishocTruongTrinhGDBo": this.state.ishocTruongTrinhGDBo,
                "iskhuyetTat": this.state.iskhuyetTat,
                "jobFather": this.state.jobFather,
                "jobGiamHo": this.state.jobGiamHo,
                "jobMother": this.state.jobMother,
                "khuyetTat": this.state.khuyetTat,
                "mailFather": this.state.mailFather,
                "mailGiamHo": this.state.mailGiamHo,
                "mailMother": this.state.mailMother,
                "motherDanToc": this.state.motherDanToc,
                "nhomMau": this.state.nhomMau,
                "noiSinh": this.state.noiSinh,
                "phone": this.state.phone,
                "phoneFather": this.state.phoneFather,
                "phoneGiamHo": this.state.phoneGiamHo,
                "phoneHome": this.state.phoneHome,
                "phoneMother":this.state.phoneMother,
                "pointDegree": this.state.pointDegree,
                "provinceCode": this.state.provinceId,
                "queQuan": this.state.queQuan,
                "religion": this.state.religion,
                "schoolDay": this.state.schoolDay,
                "sodangbo": this.state.sodangbo,
                "state": this.state.state,
                "taiDinhCu": this.state.taiDinhCu,
                "tamTru": this.state.address,
                "tengoiEthnnic": this.state.tengoiEthnnic,
                "thanhPhanParent": this.state.thanhPhanParent,
                "thuongTru": this.state.thuongTru,
                "wardCode": this.state.wardId,
                "yearId": parseInt(getSchoolYear()),
                "zone": this.state.zone
            }
            StudentController.edit(payload, res => {
                if (res.success){
                    this.props.navigate('/ad-sas-school/quan-ly-thong-tin-hoc-sinh');
                    toast.success("Sửa sinh thành công!")
                } else {
                    toast.error("Đã xảy ra lỗi! " + res.message)
                }
            })
        }
    }
    onUpdateGrade(gradeId){
        this.setState({
            gradeId: gradeId
        })
    }
    render() {
        let {gradeId, address, wardId, districtId, provinceId} = this.state
        return (
            <div>
                <div className="container">
                    <div className="row">
                        <Sidebar activeClass="menu" parentClass="menu-management"/>
                        <div className="mb-4 col-md-10 tab-content">
                            <div className="card col-12">
                                <div className='pt-3 mb-2'>
                                    <PageHeader routerEnable={true} title="Thông tin học sinh"/>
                                    <div className="mt-4 kt-form kt-form--fit kt-margin-b-20">
                                        <h2 className='text-center mb-4'>SỬA HỒ SƠ HỌC SINH</h2>
                                        <div className="row">
                                            <div className="col-12 d-flex mb-2 bg-top-title">
                                                THÔNG TIN CHUNG
                                            </div>
                                            <div className="col-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Khối</label>
                                                <GradeManager
                                                    gradeId={gradeId}
                                                    onUpdateGrade={(gradeId) => this.onUpdateGrade(gradeId)}
                                                />
                                            </div>
                                            <div className="col-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Lớp</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.currentClassRoomId}
                                                    onChange={(e) => {
                                                        this.state.currentClassRoomId = e.target.value;
                                                        this.setState({
                                                            currentClassRoomId: e.target.value,
                                                            inEditing: true
                                                        })
                                                    }}
                                                >
                                                    <option value="0">Chọn lớp</option>
                                                    {this.renderClassRoom()}
                                                </select>
                                            </div>
                                            <div className="col-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Trạng thái</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.state}
                                                    onChange={(e) => {
                                                        this.state.state = e.target.value;
                                                        this.setState({
                                                            state: e.target.value,
                                                            inEditing: true
                                                        })
                                                    }}
                                                >
                                                    <option value="">Chọn trạng thái học</option>
                                                    <option value="CHUA_PHANLOP">Chưa phân lớp</option>
                                                    <option value="DANG_HOC">Đang học</option>
                                                    <option value="CHUYEN_LOP">Tốt nghiệp</option>
                                                    <option value="NGHI_HOC">Thôi học</option>
                                                    <option value="CHUYEN_LOP">Chuyển lớp</option>
                                                    <option value="LEN_LOP ">Lên lớp</option>
                                                    <option value="CHUYEN_TRUONG">Chuyển trường</option>
                                                </select>
                                            </div>

                                            <div className="col-6 d-flex mb-2">
                                            </div>
                                            <div className="col-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Số đăng bộ</label>
                                                <input
                                                    placeholder="Nhập số đăng bộ"
                                                    maxLength={255} type="text"
                                                    className="form-control shadow-none"
                                                    value={this.state.sodangbo}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            sodangbo: event.target.value
                                                        })
                                                    }}
                                                />
                                            </div>
                                            <div className="col-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Mã học sinh</label>
                                                <input
                                                    disabled='true'
                                                    placeholder="Nhập mã học sinh"
                                                    maxLength={255} type="text"
                                                    className="form-control shadow-none"
                                                    value={this.state.code}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            code: event.target.value
                                                        })
                                                    }}
                                                />

                                            </div>
                                            <div className="col-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Họ và tên</label>
                                                <input
                                                    placeholder="Nhập họ và tên"
                                                    maxLength={255} type="text"
                                                    className="form-control shadow-none"
                                                    value={this.state.fullName}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            fullName: event.target.value
                                                        })
                                                    }}
                                                />
                                            </div>
                                            <div className="col-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Ngày sinh</label>
                                                <DatePicker
                                                    className="w-auto2 react-datepicker-wrapper2 react-datepicker__input-container form-control shadow-none"
                                                    placeholderText="Ngày sinh"
                                                    selected={this.state.birthday === null ? "" : new Date(this.state.birthday)}
                                                    minDate={new Date()}
                                                    dateFormat="dd-MM-yyyy"
                                                    isClearable={this.state.birthday === null ? false : true}
                                                    selectsStart
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    onChange={
                                                        (date) => {
                                                            this.setState({
                                                                birthday: date === null ? null : moment(date).format("YYYY-MM-DD"),
                                                            })
                                                        }
                                                    }
                                                    birthday={new Date()}
                                                />
                                            </div>
                                            <div className="col-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Giới tính</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.gender}
                                                    onChange={(e) => {
                                                        this.state.gender = e.target.value;
                                                        this.setState({
                                                            gender: e.target.value,
                                                            inEditing: true
                                                        })
                                                    }}
                                                >
                                                    <option value="MALE">Nam</option>
                                                    <option value="FEMALE">Nữ</option>
                                                    <option value="OTHER">Khác</option>
                                                </select>
                                            </div>
                                            <div className="col-6 d-flex mb-2">
                                            </div>
                                            <AddressManager
                                                addressUsually={address}
                                                districtId={districtId}
                                                provinceId={provinceId}
                                                wardId={wardId}
                                                onUpdateAddress={(address, wardId, districtId, provinceId) => this.setState({address: address, districtId: districtId, provinceId: provinceId, wardId: wardId})}
                                            />
                                            <div className="col-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Ngày vào trường</label>
                                                <DatePicker
                                                    className="w-auto2 react-datepicker-wrapper2 react-datepicker__input-container form-control shadow-none"
                                                    placeholderText="Ngày vào trường"
                                                    selected={this.state.schoolDay === null ? "" : new Date(this.state.schoolDay)}
                                                    minDate={new Date()}
                                                    dateFormat="dd-MM-yyyy"
                                                    isClearable={this.state.schoolDay === null ? false : true}
                                                    selectsStart
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    onChange={
                                                        (date) => {
                                                            this.setState({
                                                                schoolDay: date === null ? null : moment(date).format("YYYY-MM-DD"),
                                                            })
                                                        }
                                                    }
                                                    schoolDay={new Date()}
                                                />
                                            </div>
                                            <div className="col-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Hình thức</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.hinhThuc}
                                                    onChange={(e) => {
                                                        this.state.hinhThuc = e.target.value;
                                                        this.setState({
                                                            hinhThuc: e.target.value,
                                                            inEditing: true
                                                        })
                                                    }}
                                                >
                                                    <option value="TRUNG_TUYEN">Xét tuyển</option>
                                                    <option value="TRUNG_TUYEN">Trúng tuyển</option>
                                                    <option value="TRUNG_TUYEN">Chuyển đến từ trường khác</option>
                                                </select>
                                            </div>
                                            <div className="col-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Nơi sinh</label>
                                                <input
                                                    maxLength={255} type="text"
                                                    className="form-control shadow-none"
                                                    value={this.state.noiSinh}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            noiSinh: event.target.value
                                                        })
                                                    }}
                                                />
                                            </div>
                                            <div className="col-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Quê quán</label>
                                                <input
                                                    maxLength={255} type="text"
                                                    className="form-control shadow-none"
                                                    value={this.state.queQuan}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            queQuan: event.target.value
                                                        })
                                                    }}
                                                />
                                            </div>
                                            <div className="col-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Địa chỉ thường trú</label>
                                                <input
                                                    placeholder="Nơi sinh ra"
                                                    maxLength={255} type="text"
                                                    className="form-control shadow-none"
                                                    value={this.state.thuongTru}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            thuongTru: event.target.value
                                                        })
                                                    }}
                                                />
                                            </div>
                                            <div className="col-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Địa chỉ tạm chú</label>
                                                <input
                                                    placeholder="Nơi sống hiện tại"
                                                    maxLength={255} type="text"
                                                    className="form-control shadow-none"
                                                    value={this.state.address}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            address: event.target.value
                                                        })
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-12 d-flex mb-2 bg-top-title">
                                                THÔNG TIN CÁ NHÂN
                                            </div>
                                            <div className="col-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Dân tộc</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.ethnic}
                                                    onChange={(e) => {
                                                        this.state.ethnic = e.target.value;
                                                        this.setState({
                                                            ethnic: e.target.value,
                                                            inEditing: true
                                                        })
                                                    }}
                                                >
                                                    <option value="KINH">Kinh</option>
                                                    <option value="OTHER">Khác</option>
                                                </select>
                                            </div>
                                            <div className="col-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Tôn giáo</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.religion}
                                                    onChange={(e) => {
                                                        this.state.religion = e.target.value;
                                                        this.setState({
                                                            religion: e.target.value,
                                                            inEditing: true
                                                        })
                                                    }}
                                                >
                                                    <option value="NO">Không</option>
                                                    <option value="YES">Có</option>
                                                </select>
                                            </div>
                                            <div className="col-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Đối tượng ưu tiên</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.doiTuongUuTien}
                                                    onChange={(e) => {
                                                        this.state.doiTuongUuTien = e.target.value;
                                                        this.setState({
                                                            doiTuongUuTien: e.target.value,
                                                            inEditing: true
                                                        })
                                                    }}
                                                >
                                                    <option value="UU_TIEN_1">Chọn đối tượng ưu tiên</option>
                                                    <option value="UU_TIEN_1">Ưu tiên loại 1</option>
                                                    <option value="UU_TIEN_1">Ưu tiên loại 2</option>
                                                </select>
                                            </div>
                                            <div className="col-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Đối tượng chính sách</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.cheDoChinhSach}
                                                    onChange={(e) => {
                                                        this.state.cheDoChinhSach = e.target.value;
                                                        this.setState({
                                                            cheDoChinhSach: e.target.value,
                                                            inEditing: true
                                                        })
                                                    }}
                                                >
                                                    <option value="">Chọn</option>
                                                    <option value="CHE_DO_CHINH_SACH_1">Con thương binh</option>
                                                    <option value="CHE_DO_CHINH_SACH_1">Con bệnh binh</option>
                                                    <option value="CHE_DO_CHINH_SACH_1">Con liệt sỹ</option>
                                                </select>
                                            </div>
                                            <div className="col-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Số điện thoại</label>
                                                <input
                                                    placeholder="SĐT học sinh"
                                                    maxLength={255} type="text"
                                                    className="form-control shadow-none"
                                                    value={this.state.phone}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            phone: event.target.value
                                                        })
                                                    }}
                                                />
                                            </div>
                                            <div className="col-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Email</label>
                                                <input
                                                    placeholder="Email học sinh"
                                                    maxLength={255} type="email"
                                                    className="form-control shadow-none"
                                                    value={this.state.email}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            email: event.target.value
                                                        })
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-12 d-flex mb-2 bg-top-title">
                                                THÔNG TIN GIA ĐÌNH
                                            </div>
                                            <div className="col-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Thành phần gia đình</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.thanhPhanParent}
                                                    onChange={(e) => {
                                                        this.state.thanhPhanParent = e.target.value;
                                                        this.setState({
                                                            thanhPhanParent: e.target.value,
                                                            inEditing: true
                                                        })
                                                    }}
                                                >
                                                    <option value="THANH_PHAN_PARENT_1">Chọn thành phần gia đình</option>
                                                    <option value="THANH_PHAN_PARENT_1">Chọn thành phần gia đình</option>
                                                </select>
                                            </div>

                                            <div className="col-5 d-flex mb-2">
                                                <div className="checkbox clearfix mr-5">
                                                    <label>
                                                        <input
                                                            type="checkbox"
                                                            onChange={(e) => {
                                                                const value = this.state.fatherDanToc;
                                                                this.setState({fatherDanToc: !value});
                                                            }}
                                                            checked={this.state.fatherDanToc}
                                                        />
                                                        {' '}
                                                        Có bố là dân tộc
                                                    </label>
                                                </div>
                                                <div className="checkbox clearfix">
                                                    <label>
                                                        <input
                                                            type="checkbox"
                                                            onChange={(e) => {
                                                                const value = this.state.motherDanToc;
                                                                this.setState({motherDanToc: !value});
                                                            }}
                                                            checked={this.state.motherDanToc}
                                                        />
                                                        {' '}
                                                        Có mẹ là dân tộc
                                                    </label>
                                                </div>
                                            </div>
                                            <div className="col-12 d-flex mb-2 row">
                                                <label className="col-1 label-item pl-0">Họ tên cha</label>
                                                <input
                                                    maxLength={255} type="text"
                                                    className="form-control shadow-none col-2 mr-1"
                                                    value={this.state.fullNameFather}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            fullNameFather: event.target.value
                                                        })
                                                    }}
                                                />
                                                <input
                                                    placeholder="Năm sinh cha"
                                                    maxLength={255} type="text"
                                                    className="form-control shadow-none  col-2 mr-1"
                                                    value={this.state.birthdayFather}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            birthdayFather: event.target.value
                                                        })
                                                    }}
                                                />
                                                <input
                                                    placeholder="Nghề nghiệp cha"
                                                    maxLength={255} type="text"
                                                    className="form-control shadow-none  col-2 mr-1"
                                                    value={this.state.jobFather}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            jobFather: event.target.value
                                                        })
                                                    }}
                                                />
                                                <input
                                                    placeholder="SĐT cha"
                                                    maxLength={255} type="text"
                                                    className="form-control shadow-none  col-2 mr-1"
                                                    value={this.state.phoneFather}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            phoneFather: event.target.value
                                                        })
                                                    }}
                                                />
                                                <input
                                                    placeholder="Gmail cha"
                                                    maxLength={255} type="text"
                                                    className="form-control shadow-none  col-2 mr-1"
                                                    value={this.state.mailFather}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            mailFather: event.target.value
                                                        })
                                                    }}
                                                />
                                            </div>
                                            <div className="col-12 d-flex mb-2 row">
                                                <label className="col-1 label-item pl-0">Họ tên mẹ</label>
                                                <input
                                                    maxLength={255} type="text"
                                                    className="form-control shadow-none col-2 mr-1"
                                                    value={this.state.fullNameMother}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            fullNameMother: event.target.value
                                                        })
                                                    }}
                                                />
                                                <input
                                                    placeholder="Năm sinh mẹ"
                                                    maxLength={255} type="text"
                                                    className="form-control shadow-none  col-2 mr-1"
                                                    value={this.state.birthdayMother}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            birthdayMother: event.target.value
                                                        })
                                                    }}
                                                />
                                                <input
                                                    placeholder="Nghề nghiệp mẹ"
                                                    maxLength={255} type="text"
                                                    className="form-control shadow-none  col-2 mr-1"
                                                    value={this.state.jobMother}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            jobMother: event.target.value
                                                        })
                                                    }}
                                                />
                                                <input
                                                    placeholder="SĐT mẹ"
                                                    maxLength={255} type="text"
                                                    className="form-control shadow-none  col-2 mr-1"
                                                    value={this.state.phoneMother}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            phoneMother: event.target.value
                                                        })
                                                    }}
                                                />
                                                <input
                                                    placeholder="Gmail mẹ"
                                                    maxLength={255} type="text"
                                                    className="form-control shadow-none  col-2 mr-1"
                                                    value={this.state.mailMother}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            mailMother: event.target.value
                                                        })
                                                    }}
                                                />
                                            </div>
                                            <div className="col-12 d-flex mb-2 row">
                                                <label className="col-1 label-item pl-0">Họ tên người bảo hộ</label>
                                                <input
                                                    maxLength={255} type="text"
                                                    className="form-control shadow-none col-2 mr-1"
                                                    value={this.state.fullNameGiamHo}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            fullNameGiamHo: event.target.value
                                                        })
                                                    }}
                                                />
                                                <input
                                                    placeholder="Năm sinh NBH"
                                                    maxLength={255} type="text"
                                                    className="form-control shadow-none  col-2 mr-1"
                                                    value={this.state.birthdayGiamHo}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            birthdayGiamHo: event.target.value
                                                        })
                                                    }}
                                                />
                                                <input
                                                    placeholder="Nghề nghiệp NBH"
                                                    maxLength={255} type="text"
                                                    className="form-control shadow-none  col-2 mr-1"
                                                    value={this.state.jobGiamHo}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            jobGiamHo: event.target.value
                                                        })
                                                    }}
                                                />
                                                <input
                                                    placeholder="SĐT NBH"
                                                    maxLength={255} type="text"
                                                    className="form-control shadow-none  col-2 mr-1"
                                                    value={this.state.phoneGiamHo}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            phoneGiamHo: event.target.value
                                                        })
                                                    }}
                                                />
                                                <input
                                                    placeholder="Gmail NBH"
                                                    maxLength={255} type="text"
                                                    className="form-control shadow-none  col-2 mr-1"
                                                    value={this.state.mailGiamHo}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            mailGiamHo: event.target.value
                                                        })
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="align-right col-12">
                                    <div className="d-flex justify-content-center align-center mt-3 mb-2">
                                        <button
                                            type="button"
                                            className="ml-4 col-1 border-1-s background-btn type-button-fix btn btn-primary shadow-none"
                                            disabled={this.state.fullName == ""}
                                            onClick={()=> {
                                                this.onEdit()
                                            }}
                                        >
                                            Lưu
                                        </button>
                                        <button
                                            type="button"
                                            className="ml-4  border-1-s type-button-fix btn btn-light shadow-none"
                                        >
                                            <Link
                                                style={{color: '#000'}}
                                                to={{
                                                    pathname: "/ad-sas-school/quan-ly-thong-tin-hoc-sinh"
                                                }}
                                            >
                                                Hủy bỏ
                                            </Link>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default withRouter(EditMenuManagement)